import React, { useEffect, useState } from 'react';
import { getProjectList } from '../../../api/portfolio';

function Portfolio() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getProjectList()
      .then(setProjects)
      .catch((err) => setError(err.message || 'Failed to load projects'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="sec-box portfolio main-bg section-padding radius-15">
      <div className="sec-head mb-30 text-center">
        <h6 className="sub-title opacity-7 mb-15">Portfolio</h6>
        <h3>
          Look at my <span className="main-color">Projects</span>
        </h3>
      </div>
      <div className="gallery">
        <div className="row">
          {loading && (
            <div className="col-12 text-center">
              <p className="opacity-7">Loading projects...</p>
            </div>
          )}
          {error && !loading && (
            <div className="col-12 text-center">
              <p className="opacity-7">Could not load projects: {error}</p>
            </div>
          )}
          {!loading &&
            !error &&
            projects.map((item, index) => (
              <div key={item.id ?? index} className="col-lg-4 items">
                <div className="item mt-50">
                  <div className="img">
                    <a href={`/single-project/${item.id}`}>
                      <img src={item['Project Cover']} alt="" />
                    </a>
                  </div>
                  <div className="cont mt-30 d-flex align-items-center">
                    <div>
                      <span className="tag">Branding</span>
                      <h6 className="line-height-1">
                        <a href={`/single-project/${item.id}`}>{item['Project Title']}</a>
                      </h6>
                    </div>
                    <div className="ml-auto">
                      <div className="arrow">
                        <a href={`/single-project/${item.id}`}>
                          <svg
                            className="arrow-right"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 34.2 32.3"
                            xmlSpace="preserve"
                            style={{ strokeWidth: 2 }}
                          >
                            <line x1="0" y1="16" x2="33" y2="16"></line>
                            <line x1="17.3" y1="0.7" x2="33.2" y2="16.5"></line>
                            <line x1="17.3" y1="31.6" x2="33.5" y2="15.4"></line>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
